import React, { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const DynamicPopover = ({ children, isLoading, linkText, onToggleOpen, dataFields }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [alignClass, setAlignClass] = useState(null)
    const myRef = useRef(null)

    useEffect(() => {
        const handleOutsideBlockClick = (evt) => {
            if (myRef.current && !myRef.current.contains(evt.target)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('click', handleOutsideBlockClick, true)
        return () => {
            document.removeEventListener('click', handleOutsideBlockClick, true)
        }
    }, [])

    useEffect(() => {
        if (myRef.current && myRef.current.closest('.container')) {
            if (isOpen) {
                myRef.current.closest('.container').classList.add('show-popover')
            } else {
                myRef.current.closest('.container').classList.remove('show-popover')
            }
        }
    }, [isOpen])

    useEffect(() => {
        if (isOpen && !isLoading && !alignClass) {
            let leftPos = myRef.current.getBoundingClientRect().x
            let pWidth = myRef.current.querySelector('.popover-content').getBoundingClientRect().width
            let pBottom = myRef.current.querySelector('.popover-content').getBoundingClientRect().bottom
            let windowWidth = window.innerWidth
            let windowHeight = window.innerHeight
            if (leftPos + pWidth > windowWidth) {
                // Were going to overflow the right side of the screen, check that were not going off the bottom
                if (pBottom > windowHeight) {
                    setAlignClass('right-align bottom-align')
                } else {
                    setAlignClass('right-align')
                }
            } else if (pBottom > windowHeight) {
                // Were going to overflow the bottom of the screen
                setAlignClass('bottom-align')
            }
        } else if (!isOpen) {
            setAlignClass(null)
        }
    }, [isOpen, alignClass, isLoading])

    const toggleOpen = () => {
        onToggleOpen()
        setIsOpen(true)
    }

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className="resource-tile">
                    <div className="content">
                        <span className="label-header">Loading...</span>
                    </div>
                </div>
            )
        }
        return children
    }
    return (
        <div className="dynamic-popover-wrapper" ref={myRef}>
            <span className="dynamic-popover-trigger" onClick={toggleOpen} {...dataFields}>
                {linkText}
            </span>
            {isOpen &&
                <div className={`popover ${alignClass}`}>
                    <div className="popover-closer" onClick={() => setIsOpen(false)}>
                        <FontAwesomeIcon icon="times" />
                    </div>
                    <div className="popover-content">
                        { renderContent() }
                    </div>
                </div>
            }
        </div>
    )
}
export default DynamicPopover
